<template>
	<v-dialog
		v-model="dialog"
		max-width="400"
		persistent
		scrollable
		:fullscreen="fullscreen"
		@keydown.esc="onCancel"
		@keydown.ctrl.l="log=!log"
	>
		<template v-slot:activator="{ props: activatorProps }">
			<slot name="activator" :props="activatorProps">
				<v-btn v-bind="activatorProps" icon="mdi-camera-plus" color="indigo" :disabled="disabled"></v-btn>
			</slot>
		</template>

		<template v-slot:default="{ isActive }">
			<v-card>
				<v-toolbar prominent>
					<v-app-bar-nav-icon>
						<v-icon v-if="tab==0" :disabled="!photos.length" @click="tab=1">mdi-camera-image</v-icon>
						<v-icon v-if="tab==1" @click="tab=0">mdi-camera</v-icon>
					</v-app-bar-nav-icon>
					<v-spacer></v-spacer>
					<v-btn v-if="selected != null" icon="mdi-delete-outline" @click="onDelete"></v-btn>
					<v-spacer></v-spacer>
					<v-btn icon="mdi-close" @click="onClose"></v-btn>
				</v-toolbar>
				<v-card-text>
					<v-tabs-window v-model="tab">
						<v-tabs-window-item>
							<camera
								ref="camera"
								:resolution="resolution"
								autoplay
								playsinline
							></camera>
							<!-- :resolution="resolution" -->
						</v-tabs-window-item>
						<v-tabs-window-item>
							<v-carousel 
								v-model="selected"
								:hide-delimiters="!photos.length"
							>
								<v-carousel-item v-for="(photo, i) in photos" :key="i"
									:src="getUrl(photo)"
									cover
								>
								</v-carousel-item>
							</v-carousel>
						</v-tabs-window-item>
					</v-tabs-window>

					<!-- <v-slide-group 
						v-model="selected"
						show-arrows
						:multiple="multiple"
					>
						<v-slide-group-item v-for="(photo, i) in photos" :key="i" 
							v-slot="{ isSelected, toggle, selectedClass }"
						>
							<v-card
								:color="isSelected ? 'primary' : 'grey-lighten-1'"
								class="ma-2"
								height="64"
								width="64"
								@click="toggle"
								:elevation="isSelected?8:0"
							>
								<v-img :src="getUrl(photo)" :aspect-ratio="1" cover>
									
									<div class="d-flex fill-height align-end justify-end" v-if="isSelected">
										<v-scale-transition>
											<v-icon
												color="white"
												icon="mdi-check"
												size="24"
											></v-icon>
										</v-scale-transition>
									</div>
								</v-img>
							</v-card>
						</v-slide-group-item>
					</v-slide-group> -->
				</v-card-text>
				
				<v-card-actions class="justify-center">
					<v-slide-group 
						v-model="selected"
						show-arrows
						:multiple="multiple"
					>
						<v-slide-group-item v-for="(photo, i) in photos" :key="i" 
							v-slot="{ isSelected, toggle, selectedClass }"
						>
							<v-card
								:color="isSelected ? 'primary' : 'grey-lighten-1'"
								class="ma-2"
								height="64"
								width="64"
								@click="toggle"
								:elevation="isSelected?8:0"
							>
								<v-img :src="getUrl(photo)" :aspect-ratio="1" cover>
									
									<div class="d-flex fill-height align-end justify-end" v-if="isSelected">
										<v-scale-transition>
											<v-icon
												color="white"
												icon="mdi-check"
												size="24"
											></v-icon>
										</v-scale-transition>
									</div>
								</v-img>
							</v-card>
						</v-slide-group-item>
					</v-slide-group>
				</v-card-actions>
				<v-card-actions>
					<v-btn icon="mdi-camera-switch" @click="onCameraSwitch"></v-btn>
					<v-spacer></v-spacer>
					<v-btn icon="mdi-camera" variant="outlined" @click="onCamera"></v-btn>
					<v-spacer></v-spacer>
					<v-btn icon="mdi-check-bold" variant="tonal" @click="onOK"></v-btn>
				</v-card-actions>
				<v-snackbar v-model="snackbar.visible">
					{{ snackbar.text }}
					<template v-slot:actions>
						<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
					</template>
				</v-snackbar>
			</v-card>
		</template>
	</v-dialog>
</template>

<script>
import Camera from 'simple-vue-camera';

export default {
	name: 'DialogCamera',
	components: {
		Camera,
	},

	data: () => ({
		dialog: false,
		log: false,

		photos: [],				// Зроблені фото
		selected: null,

		tab: 0,

		snackbar: {
			visible: false,
			text: null
		},
	}),
	props: {
		title:       				{ type: String, default: 'Confirm delete' },
		text:       				{ type: String, default: 'Are you sure you want to delete this record?' },
		disabled:   				{ type: Boolean, default: false }, //Ознака неактивного елементу
		multiple:   				{ type: Boolean, default: false },
		type:       				{ type: String, default: 'image/png' },
		//quality:					{ type: Number, default: 0.5 },
		quality:					{ type: Number, default: 1 },
		resolution:					{ type: Object, default: () => ({ width: 1920, height: 1080 }) },
		//resolution:					{ type: Object, default: () => ({ width: 1080, height: 1920 }) },
		//resolution:					{ type: Object, default: () => ({ width: 375, height: 812 }) },
		//resolution:					{ type: Object, default: () => ({ width: 800, height: 600 }) },
		//resolution:					{ type: Object, default: () => ({ width: 600, height: 800 }) },
		fullscreen: 				{ type: Boolean, default: false},
	},

	computed: {
		photosLength() {
			return this.photos.length
		},
	},

	watch: {
		/* selected: function (val) {
			console.log(this.$options.name, 'selected','val', val)
		}, */

		photosLength: function (val, oldVal) {
			if(val==0) {
				this.tab = 0
			}
			//console.log(this.$options.name, 'selected','val', val)
		},
	},
	
	/* mounted () {
		console.log(this.$vuetify.display.mobile);

	}, */

	created() {
		/* this.camera = Array.isArray(this.$refs.camera) ? this.$refs.camera[0] : this.$refs.camera
		if(this.camera) {
			this.devices = camera.value?.devices(["videoinput"]);
		} */
		/* const camera = Array.isArray(this.$refs.camera) ? this.$refs.camera[0] : this.$refs.camera
		console.log(this.$options.name, 'created','camera', camera)

		const devices = camera.value?.devices(["videoinput"]);
		devices.forEach((device) => {
			console.log(this.$options.name, 'created','device', device)
		}) */
		//const device = devices[0];
		//camera.value?.changeCamera(device.deviceId);
	},

	methods: {
		onClear() {
			this.photos 		= []
			this.selected 		= null
			this.tab 			= 0
		},

		onClose () {
			this.dialog = false
			this.onClear()
			this.$emit('close')
		},

		onCancel () {
			this.onClose()
		},

		onOK () {
			//let result = []

			//console.log(this.$options.name, 'onOK','selected', this.selected)

			if(Array.isArray(this.selected)) {
				//console.log(this.$options.name, 'onOK','isArray')
				this.$emit('ok', this.selected.map((element) => this.photos[element]))
			//} else if(this.selected && this.selected >= 0) {
			} else if(this.selected && !Number.isNaN(this.selected)) {
				//console.log(this.$options.name, 'onOK','isNumber')
				this.$emit('ok', [this.photos[this.selected]])
			} else {
				//console.log(this.$options.name, 'onOK','isPhotos')
				this.$emit('ok', this.photos)
			}

			//this.$emit('ok', result)

			this.onClose()
		},

		onCamera() {
			//console.log(this.$options.name, 'onCamera', 'camera', this.$refs.camera)

			const camera = Array.isArray(this.$refs.camera) ? this.$refs.camera[0] : this.$refs.camera

			//console.log(this.$options.name, 'onCamera', 'camera', camera)
			
			//const resolution = camera.resolution;
			const resolution = this.$vuetify.display.mobile ? { width: camera.resolution.height, height: camera.resolution.width } : camera.resolution;
			//console.log(this.$options.name, 'onCamera', 'resolution', resolution)

			//FOR TEST
			//this.snackbar.visible 	= true;
			//this.snackbar.text 		= `width:${resolution.width}, height:${resolution.height}`;

			const snapshot = async () => {
				
				const blob = await camera?.snapshot(
					resolution,
					this.type,
					this.quality 
				);
				//const blob = await camera?.snapshot();
				if(blob) {
					//console.log(this.$options.name, 'onCamera', 'blob', blob)

					//const url = URL.createObjectURL(blob);
					
					//console.log(this.$options.name, 'onCamera', 'url', url)

					this.photos.push(blob)
				}
			}

			snapshot();
		},

		getUrl(blob) {
			if(blob) {
				const url = URL.createObjectURL(blob);
				return url
			}
		},

		onCameraSwitch() {
			let messages = []

			var logBackup = console.log;
			//var logMessages = [];

			/* console.log = function() {
				//logMessages.push.apply(logMessages, arguments);
				messages.push.apply(messages, arguments);
				logBackup.apply(console, arguments);
			}; */

			messages.push('onCameraSwitch')

			const camera = Array.isArray(this.$refs.camera) ? this.$refs.camera[0] : this.$refs.camera
			if(camera) {
				//console.log(this.$options.name, 'onCameraSwitch', 'camera', camera)
				const currentDeviceID = camera.currentDeviceID();
				
				//console.log(this.$options.name, 'onCameraSwitch', 'currentDeviceID', currentDeviceID)
				//console.log(this.$options.name, 'onCameraSwitch', 'currentDeviceID', currentDeviceID)
				messages.push(`currentDeviceID: ${currentDeviceID}`)

				//const devices = camera?.devices(["videoinput"]);
				//const devices = camera.value?.devices(["videoinput"]);
				const devices = camera?.devices
				if(devices && devices.length > 1) {

					//console.log(this.$options.name, 'onCameraSwitch', 'devices', devices)
					messages.push(`devices: ${devices.length}`)

					if(Array.isArray(devices)) {
						const currentDeviceIndex = devices.findIndex((element) => element.deviceId==currentDeviceID)
						const deviceIndex = currentDeviceIndex < devices.length - 1 ? currentDeviceIndex + 1 : 0

						camera?.changeCamera(devices[deviceIndex].deviceId);
					} else {
						camera?.changeCamera(devices.deviceId);
					}

					//console.log(this.$options.name, 'onCameraSwitch', 'devices', devices)
					const devicesCount = Array.isArray(devices) ? devices.length : 1;

					this.deviceIndex = this.deviceIndex < devicesCount - 1 ? this.deviceIndex + 1 : 0
					
					const device = Array.isArray(devices) ? devices[0] : devices;
					if(device) {
						//console.log(this.$options.name, 'onCameraSwitch', 'device', device)

						camera?.changeCamera(device.deviceId);
					}
				} else {
					messages.push('No devices videoinput')
				}
			} else {
				messages.push('No camera')
			}

			//this.snackbar.visible 	= messages.length;
			//this.snackbar.text 		= messages.join(' | ');
		},

		onDelete() {
			//console.log(this.$options.name, 'onDelete','selected', this.selected)

			if(Array.isArray(this.selected)) {
				let result = this.selected.map((element) => this.photos[element])
				result.forEach((element) => {
					const index = this.photos.indexOf(element)
					this.photos.splice(index, 1);
				})
			} else if(this.selected >= 0) {
				const index = this.selected
				this.photos.splice(index, 1);
			}

			this.selected = null

			/* if(Array.isArray(this.selected) || this.selected >= 0) {
				if(this.multiple) {
					let result = this.selected.map((element) => this.photos[element])
					result.forEach((element) => {
						const index = this.photos.indexOf(element)
						this.photos.splice(index, 1);
					})

					//console.log(this.$options.name, 'onOK','result', result)
				} else {
					console.log(this.$options.name, 'onOK','selected', this.selected)

					const index = this.selected
					this.photos.splice(index, 1);
				}

				this.selected = null
			} */
		},

		removePhoto(index) {
			this.photos.splice(index, 1)
			/* if(index > this.photos.length-1) { 
				//this.photoIndex = this.photos.length-1
				this.selected = this.photos.length-1
			} */
			/* if(index < this.photos.length-1) { 
				//this.photoIndex = this.photos.length-1
				this.selected = index-1
			} */
			

			//console.log('ScenariumPlay.vue', 'removePhoto', 'index', index)
			//console.log('ScenariumPlay.vue', 'removePhoto', 'selected', this.selected)
		},
	},
}
</script>